import React from 'react';
import { MLabel, MIcon } from 'src/theme';
import { PATH_CUSTOMER, PATH_STAFF } from 'src/routes/paths';


import { Icon } from '@iconify/react';
import bxHome from '@iconify/icons-bx/bx-home';
import bookIcon from '@iconify/icons-akar-icons/book';
import bellFill from '@iconify-icons/eva/bell-fill';
import bxsOffer from '@iconify/icons-bx/bxs-offer';
import boxIcon from '@iconify/icons-la/box';
import fileInvoice from '@iconify/icons-la/file-invoice';
import creditCardOutlined from '@iconify/icons-ant-design/credit-card-outlined';
import moneyBill from '@iconify/icons-fa-solid/money-bill';
import buildingWarehouse from '@iconify/icons-tabler/building-warehouse';
import personIcon from '@iconify/icons-akar-icons/person';
import reportIcon from '@iconify/icons-carbon/report';

import idCard from '@iconify/icons-bx/id-card';
import groupIcon from '@iconify/icons-el/group';

import paymentUpdate from '@iconify/icons-tabler/file-dollar';

// ----------------------------------------------------------------------

const path = (name) => `/static/icons/navbar/${name}.svg`;

const ICONS = {
  home: <Icon icon={bxHome} style={{ width: '2em', height: '2em'}}/>,
  userGuide: <Icon icon={bookIcon} style={{ width: '2em', height: '2em'}}/>,
  notifications: <Icon icon={bellFill} style={{ width: '2em', height: '2em'}}/>,
  offers: <Icon icon={bxsOffer} style={{ width: '2em', height: '2em'}}/>,
  preOrder: <Icon icon={boxIcon} style={{ width: '2em', height: '2em'}}/>,
  order: <Icon icon={fileInvoice} style={{ width: '2em', height: '2em'}}/>,
  payment: <Icon icon={creditCardOutlined} style={{ width: '2em', height: '2em'}}/>,
  distributor: <Icon icon={buildingWarehouse} style={{ width: '2em', height: '2em'}}/>,
  report: <Icon icon={reportIcon} style={{ width: '2em', height: '2em'}}/>,
  profile: <Icon icon={personIcon} style={{ width: '2em', height: '2em'}}/>,
  reportIcon: <Icon icon={reportIcon} style={{ width: '2em', height: '2em'}}/>,
  companyAccount: <Icon icon={idCard} style={{ width: '2em', height: '2em' }}/>,
  staffIcon: <Icon icon={groupIcon} style={{ width: '2em', height: '2em' }}/>,
  creditNote: <Icon icon={moneyBill} style={{ width: '2em', height: '2em' }}/>,
  paymentUpdate: <Icon icon={paymentUpdate} style={{ width: '2em', height: '2em' }}/>
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      {
        title: 'notifications',
        icon: ICONS.notifications,
        access: 'notifications',
        href: PATH_STAFF.general.notifications,
        badgeModule: 'notification'
      },
      {
        title: 'company profile',
        icon: ICONS.companyAccount,
        access: 'companyProfile',
        href: PATH_STAFF.general.retailerApplicationForm,
        badgeModule: 'companyProfileRetailer'
      }
    ]
  },
  {
    subheader: 'pre-order',
    items: [
      {
        title: 'offers',
        icon: ICONS.offers,
        href: PATH_STAFF.general.root,
        access: 'offers',
      },
      {
        title: 'pre-order',
        icon: ICONS.preOrder,
        href: PATH_STAFF.general.preOrder.root,
        access: 'preOrder',
      }
    ]
  }
];

export default navConfig;
